import { render, staticRenderFns } from "./LayoutTicketList.vue?vue&type=template&id=7a476142&scoped=true&"
import script from "./LayoutTicketList.vue?vue&type=script&lang=ts&"
export * from "./LayoutTicketList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a476142",
  null
  
)

export default component.exports